import { useCallback, useState } from "react";
import useAxiosPrivate from "../../../hooks/server/useAxiosPrivate";
import { useDispatch } from "react-redux";
import { authProviderActions } from "../../../store/auth/auth-provider";

function useUserProfile() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const axiosPrivate = useAxiosPrivate();
  const dispatch = useDispatch();

  const getUserProfile = useCallback(async () => {
    setLoading(true);
    dispatch(authProviderActions.setLoadingUserInfo(true));
    try {
      const response = await axiosPrivate.get("/api/auth/me");

      dispatch(authProviderActions.setUser(response.data));
      return response.data;
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      dispatch(authProviderActions.setLoadingUserInfo(false));
    }
  }, []);

  return [getUserProfile, loading, error];
}

export default useUserProfile;
